const endpoints = {
  //bootstrap
  getBootstrap: () => "/bootstrap",
  getBootstrapGuest: () => "/bootstrap/guest",
  // courses
  logInteraction: (portalId: string, userId: string, assignmentId: string) =>
    `/client/portal/${portalId}/user/${userId}/assignment/${assignmentId}/logInteraction`,
  getHomeAssignments: (userId: string, portalId: string) =>
    `/client/portal/${portalId}/user/${userId}/assignment`,
  createNote: (portalId: string, userId: string, assignmentId: string) =>
    `/client/portal/${portalId}/user/${userId}/assignment/${assignmentId}/note`,
  updateNote: (
    portalId: string,
    userId: string,
    assignmentId: string,
    noteId: string,
  ) =>
    `/client/portal/${portalId}/user/${userId}/assignment/${assignmentId}/note/${noteId}`,
  undoDeleteNote: (
    portalId: string,
    userId: string,
    assignmentId: string,
    noteId: string,
  ) =>
    `/client/portal/${portalId}/user/${userId}/assignment/${assignmentId}/note/${noteId}/undo`,
  submitAcknowledgement: (
    portalId: string,
    userId: string,
    assignmentId: string,
  ) =>
    `/client/portal/${portalId}/user/${userId}/assignment/${assignmentId}/acknowledgement`,
  getUserAssignment: (portalId: string, userId: string, assignmentId: string) =>
    `/client/portal/${portalId}/user/${userId}/assignment/${assignmentId}`,
  getCertificates: (portalId: string, userId: string) =>
    `/client/portal/${portalId}/user/${userId}/certificate`,
  getMyProfile: (portalId: string, userId: string) =>
    `/client/portal/${portalId}/user/${userId}/myprofile`,
  updateMyProfile: (portalId: string, userId: string) =>
    `/client/portal/${portalId}/user/${userId}/myprofile`,

  // auth
  login: () => "/auth/login",
  signup: () => "/auth/signup",
  createUser: () => "/admin/portal/user",
  firstTimeLogin: () => "/auth/first-time-login",
  validateEmail: () => "/auth/validate-email-link",
  changePassword: () => "/auth/change-password",
  forgotPassword: () => "/auth/forgot-password",
  confirmForgotPassword: () => "/auth/confirm-forgot-password",
  logout: () => "/auth/logout",
  getUser: () => "/admin/portal/usershort",
  getUserPool: () => "/admin/portal/userpool",
  reInviteUser: () => "/auth/reinvite",

  // portals configuration
  getPortals: () => "/admin/portal",
  addPortal: () => "/admin/portal/create",
  updatePortal: (portalId: string) => `/admin/portal/${portalId}/update`,
  getPortal: (portalId: string) => `/admin/portal/${portalId}`,
  getAlllanguages: () => "/admin/language",

  // user attributes
  addUserAttribute: (portalId: string) =>
    `/admin/portal/${portalId}/userAttribute`,
  getUserAttribute: (portalId: string, userAttributeId: string) =>
    `/admin/portal/${portalId}/userAttribute/${userAttributeId}`,
  getUserAttributes: (portalId: string) =>
    `/admin/portal/${portalId}/userAttribute`,
  reorderAttributes: (portalId: string, userAttributeId: string) =>
    `/admin/portal/${portalId}/userAttribute/${userAttributeId}/reorder`,

  // portal pages
  getAllPages: () => "/admin/page",
  getAllPagesForPortal: (portalId: string) => `/admin/portal/${portalId}/page`,
  setVisiblePageForPortal: (portalId: string) =>
    `/admin/portal/${portalId}/page`,

  //portal design
  getPageDesign: (portalId: string, pageId: string) =>
    `/admin/portal/${portalId}/design/${pageId}`,
  getDesignByUrl: (pageId: string) => `/admin/portal/design/${pageId}`,
  getSectionDesign: (portalId: string, pageId: string, pagesectionId: string) =>
    `/admin/portal/${portalId}/design/${pageId}/pagesection/${pagesectionId}`,
  updateSectionDesign: (
    portalId: string,
    pageId: string,
    pagesectionId: string,
  ) =>
    `/admin/portal/${portalId}/design/${pageId}/pagesection/${pagesectionId}`,

  // portal translation
  getAllPortalTranslations: (portalId: string, langId: string) =>
    `/admin/portal/${portalId}/translations/lang/${langId}`,
  getTranslationsOpen: (tabId: string) => `/admin/portal/translation/${tabId}`,
  getTranslationsProtected: (portalId: string, tabId: string, langId: string) =>
    `/admin/portal/${portalId}/translation/${tabId}/lang/${langId}`,
  getTranslationsForSection: (
    portalId: string,
    tabId: string,
    tabSectionId: string,
    langId: string,
  ) =>
    `/admin/portal/${portalId}/translation/${tabId}/tabsection/${tabSectionId}/lang/${langId}`,
  getTranslationsForSectionAttribute: (
    portalId: string,
    tabId: string,
    tabSectionId: string,
    attributeId: string,
  ) =>
    `/admin/portal/${portalId}/translation/${tabId}/tabsection/${tabSectionId}/attribute/${attributeId}`,
  updateAttributeTranslation: (
    portalId: string,
    tabId: string,
    tabSectionId: string,
  ) =>
    `/admin/portal/${portalId}/translation/${tabId}/tabsection/${tabSectionId}`,
  findOrTranslate: (portalId: string, langId: string) =>
    `/admin/portal/${portalId}/translation/lang/${langId}`,
  replaceTranslation: (portalId: string, langId: string) =>
    `/admin/portal/${portalId}/translation/lang/${langId}`,

  // assignments
  getS3PresignedUrl: (portalId: string) =>
    `/admin/portal/${portalId}/presignedUrl`,
  getAssignments: (portalId: string) => `/admin/portal/${portalId}/assignment`,
  getDdlAssignments: (portalId: string) =>
    `/admin/portal/${portalId}/assignment/dependency`,
  getAssignment: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}`,
  addupdateAssignment: (portalId: string) =>
    `/admin/portal/${portalId}/assignment`,
  getPrerequisiteSummaryResult: (portalId: string, assignmentId: string) =>
    `/client/portal/${portalId}/assignment/${assignmentId}/dependency`,
  createUpdateAssignmentVersion: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/version`,
  deleteAssignmentVersion: (
    portalId: string,
    assignmentId: string,
    versionId: string,
  ) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/version/${versionId}`,
  updateIsAssigned: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}`,
  advancedUserSearch: (portalId: string) =>
    `/admin/portal/${portalId}/user/advancedsearch`,
  getPortalGroups: (portalId: string) => `/admin/portal/${portalId}/group`,
  bulkDeletePortalGroups: (portalId: string) =>
    `/admin/portal/${portalId}/group/remove`,
  createUpdatePortalGroup: (portalId: string) =>
    `/admin/portal/${portalId}/group`,

  // users management
  getUsers: (portalId: string) => `/admin/portal/${portalId}/user`,
  getUserFilters: (portalId: string) => `/admin/portal/${portalId}/user/filter`,
  createNewUser: (portalId: string) => `/admin/portal/${portalId}/user/create`,
  updateUser: (portalId: string) => `/admin/portal/${portalId}/user/update`,
  getUserWithAllDetails: (portalId: string, userId: string) =>
    `/admin/portal/${portalId}/user/${userId}`,
  getRolesForUser: (portalId: string) => `/admin/portal/${portalId}/role`,
  getUserPortalMappingsByEmail: (portalId: string) =>
    `/admin/portal/${portalId}/user/multiportal`,
  getPortalUserAttribute: (portalId: string) =>
    `/admin/portal/${portalId}/userAttribute`,
  getAdvancedUserAttributesDDL: (portalId: string) =>
    `/admin/portal/${portalId}/user/advancedddl`,
  addEditUserAttribute: (portalId: string) =>
    `/admin/portal/${portalId}/user/userAttribute`,
  bulkUpdateStatus: (portalId: string) =>
    `/admin/portal/${portalId}/user/statusChange`,

  // bulk user actions
  getTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/userImportJob/template`,
  createUpdateTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/userImportJob`,
  validateTemplate: (portalId: string, jobId: string) =>
    `/admin/portal/${portalId}/userImportJob/${jobId}/validate`,
  downloadValidationLog: (portalId: string, jobId: string) =>
    `/admin/portal/${portalId}/userImportJob/${jobId}/download`,
  reviewTemplate: (portalId: string, jobId: string) =>
    `/admin/portal/${portalId}/userImportJob/${jobId}/review`,
  userImportJobDetail: (portalId: string, jobId: string, recordId: string) =>
    `/admin/portal/${portalId}/userImportJob/${jobId}/detail/${recordId}`,
  executeUserImportJob: (portalId: string, jobId: string) =>
    `/admin/portal/${portalId}/userImportJob/${jobId}/execute`,
  userImportJobOverview: (portalId: string, jobId: string) =>
    `/admin/portal/${portalId}/userImportJob/${jobId}/overview`,

  // email templates and sending
  getEmailTemplates: (portalId: string) => `/admin/portal/${portalId}/email`,
  getEmailTemplate: (portalId: string, templateId: string) =>
    `/admin/portal/${portalId}/email/${templateId}`,
  createUpdateEmailTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/email`,
  deleteEmailTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/email/remove`,
  getEmailTemplateTypes: (portalId: string) =>
    `/admin/portal/${portalId}/email/emailTemplateType`,
  sendEmail: (portalId: string) => `/admin/portal/${portalId}/queue/message`,

  // User Assignments
  createUserAssignments: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/create`,
  editUserAssignments: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/edit`,
  editUserAssignmentStatus: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/editStatus`,
  removeUserAssignments: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/remove`,
  getAllUserAssignments: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/all`,

  // Edit Training Records
  getAllTrainingRecordsPaginated: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/trainingRecord`,
  getTrainingRecordById: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/trainingRecord/all`,
  getUserAssignmentAllTrainingRecordsPaginatedResult: (portalId: string) =>
    `/admin/portal/${portalId}/userAssignment/trainingRecord/all`,
  editTrainingRecord: (portalId: string, recordId: string) =>
    `/admin/portal/${portalId}/userAssignment/trainingRecord/${recordId}`,
  resetTrainingRecord: (portalId: string, recordId: string) =>
    `/admin/portal/${portalId}/userAssignment/trainingRecord/${recordId}/reset`,

  // Reports
  getAllReportTemplates: (portalId: string) =>
    `/admin/portal/${portalId}/report`,
  getReportTemplateDdl: (portalId: string) =>
    `/admin/portal/${portalId}/report/ddl`,
  createUpdateReportTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/report`,
  getReportTemplateById: (portalId: string, reportTemplateId: string) =>
    `/admin/portal/${portalId}/report/${reportTemplateId}`,
  deleteReportTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/report/remove`,
  runReportTemplate: (portalId: string, reportTemplateId: string) =>
    `/admin/portal/${portalId}/report/${reportTemplateId}/run`,
  previewReportTemplate: (portalId: string) =>
    `/admin/portal/${portalId}/report/preview`,
  getAssesmentReportData: (portalId: string) =>
    `/admin/portal/${portalId}/report/drilldown`,

  // Dashboard
  getDashboardAssignments: (portalId: string) =>
    `/admin/portal/${portalId}/dashboard/assignments`,
  getDashboardSessions: (portalId: string) =>
    `/admin/portal/${portalId}/dashboard/sessions`,
  getDashboardActivities: (portalId: string) =>
    `/admin/portal/${portalId}/dashboard/activities`,
  getDashboard: (portalId: string, userId?: string) => {
    const baseUrl = `/admin/portal/${portalId}/dashboard`;
    return userId ? `${baseUrl}?userId=${userId}` : baseUrl;
  },

  // File Hub
  getAllFileHubFiles: (portalId: string) => `/admin/portal/${portalId}/fileHub`,
  getFileHubById: (portalId: string, fileHubId: string) =>
    `/admin/portal/${portalId}/fileHub/${fileHubId}`,
  fileHubCreateUpdate: (portalId: string) =>
    `/admin/portal/${portalId}/fileHub`,
  deleteFileHubFiles: (portalId: string) =>
    `/admin/portal/${portalId}/fileHub/remove`,
  subscribeForEmailNotification: (portalId: string) =>
    `/admin/portal/${portalId}/fileHub/subscribe`,

  // Rules
  getAllRules: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/rule`,
  reorderRules: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/rule/reorder`,
  getRuleById: (portalId: string, assignmentId: string, ruleId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/rule/${ruleId}`,
  createUpdateRule: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/rule`,
  deleteRules: (portalId: string, assignmentId: string) =>
    `/admin/portal/${portalId}/assignment/${assignmentId}/rule`,
};

export default endpoints;
